












import { ModalMixin, Modal } from 'mycorems-app-shared';
import RetrieveEmailCampaigns from './RetrieveEmailCampaigns.vue';

export default ModalMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    isStepper: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    modal: Modal,
    'retrieve-email-campaigns': RetrieveEmailCampaigns,
  },
});
